// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__2-Us_","contained":"OpenButton_contained__21tpd","disabled":"OpenButton_disabled__2x8T2","error":"OpenButton_error__YTGLy"};